<template>
    <radio-log />
</template>

<script>

import RadioLog from '@/components/RadioLog'

export default {
    components: {
        RadioLog,
    }
}
</script>